import { render } from "./CallAttentionDetailApprove.vue?vue&type=template&id=323d0e24"
import script from "./CallAttentionDetailApprove.vue?vue&type=script&lang=js"
export * from "./CallAttentionDetailApprove.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__